import gql from "@/api/gql.js"
import {
	queryTransactions,
	queryTransactionDetail,
	queryPolicies,
	queryClaims,
	queryProposals,
	addTransaction,
	updateTransaction,
	addFactToTransaction,
	updateTransactionFact,
	removeFactFromTransaction,
	deleteTransaction,
} from "./queries.js"

export default {
	async queryTransactions(variables) {
		return new Promise(async resolve => {
			const res = await gql({
				query: queryTransactions,
				variables
			})
			resolve(res)
		})
	},

	async queryTransactionDetail(variables) {
		return new Promise(async resolve => {
			const res = await gql({
				query: queryTransactionDetail,
				variables
			})
			resolve(res)
		})
	},

	async addTransaction(variables) {
		return new Promise(async resolve => {
			const res = await gql({
				query: addTransaction,
				variables
			})
			resolve(res)
		})
	},

	async updateTransaction(variables) {
		return new Promise(async resolve => {
			const res = await gql({
				query: updateTransaction,
				variables
			})
			resolve(res)
		})
	},

	async queryPolicies(variables) {
		return new Promise(async resolve => {
			const res = await gql({
				query: queryPolicies,
				variables
			})
			resolve(res)
		})
	},

	async queryClaims(variables) {
		return new Promise(async resolve => {
			const res = await gql({
				query: queryClaims,
				variables
			})
			resolve(res)
		})
	},

	async queryProposals(variables) {
		return new Promise(async resolve => {
			const res = await gql({
				query: queryProposals,
				variables
			})
			resolve(res)
		})
	},

	async addFactToTransaction(variables) {
		return new Promise(async resolve => {
			const res = await gql({
				query: addFactToTransaction,
				variables
			})
			resolve(res)
		})
	},

	async updateTransactionFact(variables) {
		return new Promise(async resolve => {
			const res = await gql({
				query: updateTransactionFact,
				variables
			})
			resolve(res)
		})
	},

	async removeFactFromTransaction(variables) {
		return new Promise(async resolve => {
			const res = await gql({
				query: removeFactFromTransaction,
				variables
			})
			resolve(res)
		})
	},

	async deleteTransaction(variables) {
		return new Promise(async resolve => {
			const res = await gql({
				query: deleteTransaction,
				variables
			})
			resolve(res)
		})
	},
}
